// extracted by mini-css-extract-plugin
export default {"box":"Card_box__ohsp3","card_header_btn":"Card_card_header_btn__9bCR5","customIcon":"Card_customIcon__Ill8a"};